import { Dialog, DialogTitle, DialogContent, IconButton, Grid, Card, CardContent } from "@material-ui/core";
import * as React from 'react';
import CloseIcon from '@material-ui/icons/Close';

export default class RamIntegrationComponent extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
        this.state = {
            fullWidth: true,
            maxWidth: 'sm'
        }
        this.handleClose = this.handleClose.bind(this);
    }

    renderRamIntegrationData() {
        const elements: any = [];
        if (this.props.ramIntegrationData && this.props.ramIntegrationData.length > 0) {
            this.props.ramIntegrationData.forEach((ramIntegrationRow: any) => {
                elements.push(
                    <Card className={"commentsBox"}>
                        <CardContent>
                            <div className="card card-default">
                                <div className="card-body">
                                    <div className="comment-post">
                                        <span>
                                            In {ramIntegrationRow.INDICATOR_TARGET_YEAR}, 
                                            the response from '{ramIntegrationRow.COUNTRY_NAME} ({ramIntegrationRow.BUSINESS_AREA_CODE})' 
                                            in RAM for the indicator '{ramIntegrationRow.INDICATOR_DESCRIPTION}' 
                                            was '{ramIntegrationRow.INDICATOR_RATING_STATUS}' 
                                            as of '{ramIntegrationRow.INDICATOR_ASOF_DATE}'
                                        </span>
                                    </div>
                                </div>
                            </div>        
                        </CardContent>
                    </Card>
                );
            })
        }

        return elements;
    }

    handleClose() {
        this.props.onDialogClose(true);
    }

    render() {
        console.log('STATE', this.state)
        return (
            <>
                {
                    <Dialog
                        fullWidth={this.state.fullWidth}
                        hideBackdrop={true}
                        maxWidth={this.state.maxWidth}
                        open={this.props.showRamIntegrationDialog}
                        aria-labelledby="max-width-dialog-title"
                        className="applicationDialog"
                    >
                        <div className="dialogWrapper">
                            <div className="dialogHead">
                                <DialogTitle id="max-width-dialog-title" className="dialogTitle">View RAM data
                                 <IconButton aria-label="Close" className="closeButton" onClick={this.handleClose}>
                                        <CloseIcon />
                                    </IconButton>
                                    <hr className="HZDivider" />
                                </DialogTitle>
                            </div>

                            <div className="dialogContent">
                                <DialogContent>
                                    <Grid container={true} spacing={8}>
                                        <Grid item={true} xs={12}>
                                            {this.renderRamIntegrationData()}
                                        </Grid>
                                    </Grid>
                                </DialogContent>
                            </div>
                        </div>
                    </Dialog>
                }
            </>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/responses/RamIntegrationComponent.tsx